<template>
  <div class="booking-add-ons">
    <div class="booking-add-ons-wrapper">
      <div
        class="booking-add-ons-header"
      >
        <div>
          <h2 class="booking-add-ons-header-title">
            {{ title }}
          </h2>
          <p
            class="booking-add-ons-header-description"
          >
            {{ description }}
          </p>
        </div>
        <div
          role="status"
          class="booking-add-ons-header-counter"
        >
          {{ totalSelected }}
        </div>
      </div>
      <BookingAddOnsCarousel
        :add-ons-list="addOnsList"
        @select-add-on="selectAddOn($event, false)"
        @edit-add-on="selectAddOn($event, true)"
        @remove-add-on="removeAddOn"
      />
    </div>
    <transition name="slide-right">
      <booking-add-ons-sidebar
        v-if="selectedAddOn"
        v-model="selectedAddOn"
        :is-editing="isEditing"
        :outer-activator="activator"
        @done="enhancementEdited"
        @deactivate="closeSidebar"
      />
    </transition>
    <transition name="fade">
      <div
        v-if="selectedAddOn"
        class="backlight"
        @click="closeSidebar"
      />
    </transition>
  </div>
</template>

<script>
  import { mapState, mapGetters, mapActions } from 'vuex'
  import ModalAccessibility from '@mixins/modal-accessibility'
  import BookingAddOnsCarousel from './components/booking-add-ons-carousel.vue'
  import BookingAddOnsSidebar from './components/booking-add-ons-sidebar.vue'

  export default {
    name: 'BookingAddOns',
    components: {
      BookingAddOnsCarousel,
      BookingAddOnsSidebar,
    },
    mixins: [ModalAccessibility],
    data() {
      return {
        selectedAddOn: null,
        isEditing: false,
        activator: null
      }
    },
    computed: {
      ...mapState('auth', ['addOnsComponentData']),
      ...mapState('cart', ['roomAddOns']),
      ...mapState('booking', ['currentRoomId']),
      ...mapGetters('cart', ['addOnsInRoom', 'getValidAddOnsByRoomId']),
      ...mapGetters('booking', ['selectedHotel', 'currentRoom']),
      title() {
        return this.addOnsComponentData?.AddOnsTitle
      },
      description() {
        return this.addOnsComponentData?.AddOnsDescription
      },
      totalSelected() {
        const totalAddOnsSelected = this.addOnsInRoom?.length ?? 0
        return this.addOnsComponentData?.AddOnsAddedLabel?.replace('{{n}}', totalAddOnsSelected)
      },
      addOnsList() {
        const roomValidAddOns = this.getValidAddOnsByRoomId(this.currentRoomId)
        const hasValidAddOns = roomValidAddOns.length > 0
        if (hasValidAddOns) {
          return roomValidAddOns.filter((e) => this.filterByRoom(e))
        }
        return []
      },
    },
    methods: {
      ...mapActions('cart', ['addAddOnToRoom', 'removeAddOnFromRoom']),
      closeSidebar() {
        this.setPageContentAccessibility(false)
        document.querySelector('body').style.overflowY = 'auto'
        this.selectedAddOn = null
        this.activator = null
      },
      filterByRoom(e) {
        const rooms = e.addOnExcludedRooms || e.excludedRooms || []
        const filteredRooms = rooms
          .filter((room) => room.HotelCode === this.selectedHotel.id)
          .map((room) => room.RoomCode)

        return !filteredRooms.includes(this.currentRoom.bedTypeCode)
      },
      selectAddOn(addOn, isEditing) {
        if (isEditing) {
          this.activator = document.getElementById(`see-details-${addOn.sitecoreId}`)
        } else {
          this.activator = document.getElementById(`add-cta-${addOn.sitecoreId}`)
        }
        this.selectedAddOn = addOn
        this.isEditing = isEditing
      },
      async removeAddOn(addOnToRemove) {
        await this.removeAddOnFromRoom({ addOn: addOnToRemove })
      },
      async enhancementEdited() {
        await this.addAddOnToRoom({ addOn: { ...this.selectedAddOn } })
        this.closeSidebar()
      },
    }
  }
</script>
